/* ==========================================================================
   KOE-L SKYE — theme.js
   Progressive enhancement only. Every interaction below has a working
   no-JS fallback (real forms, real links), so a failed fetch never dead-ends.
   ========================================================================== */

(function () {
  'use strict';

  function $(sel, root){ return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Set by the category rail once it has bound itself, called by the router
     every time a new page lands under the header. A no-op until then, and on
     any page with no rail on it. */
  var rebindCatalogue = function () {};

  /* The other direction. Anything that changes the URL without leaving the page
     — the category rail is the only one — goes through here rather than calling
     pushState itself, so the router's idea of what <main> is showing stays true
     and the entry is stamped like every other.

     Left as a plain pushState until the router replaces it, which is also what
     runs on a browser too old to have one. */
  var routerPush = function (url, extra) {
    if (window.history && window.history.pushState) {
      window.history.pushState(extra || {}, '', url);
    }
  };

  /* --- scroll lock -------------------------------------------------------- */

  var lockCount = 0;
  var savedScroll = 0;

  function lockScroll() {
    if (lockCount === 0) {
      savedScroll = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = -savedScroll + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
    }
    lockCount++;
  }

  function unlockScroll() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, savedScroll);
    }
  }

  /* --- panels (mobile nav + cart drawer) --------------------------------- */

  var overlay = $('[data-overlay]');
  var openPanel = null;
  var lastFocus = null;

  function panelOpen(el) {
    if (!el || openPanel === el) return;
    if (openPanel) panelClose();
    lastFocus = document.activeElement;
    openPanel = el;
    el.setAttribute('data-open', 'true');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.setAttribute('data-open', 'true');
    lockScroll();
    // Focus on the next frame: the panel is still visibility:hidden in the
    // frame the attribute flips, and a hidden element cannot take focus.
    window.requestAnimationFrame(function () {
      var focusable = el.querySelector('button, [href], input, select, textarea');
      if (focusable && openPanel === el) focusable.focus({ preventScroll: true });
    });
  }

  function panelClose() {
    if (!openPanel) return;
    var el = openPanel;
    openPanel = null;
    el.setAttribute('data-open', 'false');
    el.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.setAttribute('data-open', 'false');
    unlockScroll();
    $$('[aria-expanded="true"][data-nav-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    lastFocus = null;
  }

  function currentDrawer() { return $('[data-cart-drawer]'); }

  document.addEventListener('click', function (e) {
    var navOpen = e.target.closest('[data-nav-open]');
    if (navOpen) {
      e.preventDefault();
      var nav = $('[data-mobile-nav]');
      if (nav && nav.getAttribute('data-open') === 'true') {
        panelClose();
      } else {
        navOpen.setAttribute('aria-expanded', 'true');
        panelOpen(nav);
      }
      return;
    }

    if (e.target.closest('[data-nav-close]') ||
        e.target.closest('[data-cart-close]') ||
        e.target.closest('[data-search-close]') ||
        e.target.closest('[data-popup-close]')) {
      e.preventDefault();
      panelClose();
      return;
    }

    // The search control is a button now — /search is a redirect, not a page,
    // so there is no href to suppress and nothing to fall back to.
    var searchOpen = e.target.closest('[data-search-open]');
    if (searchOpen) {
      e.preventDefault();
      panelOpen($('[data-search-panel]'));
      return;
    }

    var cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen) {
      e.preventDefault();
      panelOpen(currentDrawer());
      return;
    }

    if (e.target === overlay) panelClose();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanel) panelClose();

    // Keep tab focus inside an open panel.
    if (e.key === 'Tab' && openPanel) {
      var items = $$('button, [href], input, select, textarea', openPanel).filter(function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  /* --- predictive search ------------------------------------------------- */

  var searchPanel = $('[data-search-panel]');

  if (searchPanel) {
    var input = $('[data-search-input]', searchPanel);
    var results = $('[data-search-results]', searchPanel);
    var debounce = null;
    var inFlight = null;
    var lastTerm = '';

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function clearResults() {
      results.innerHTML = '';
      lastTerm = '';
    }

    function resultLinks() {
      return $$('[data-search-result]', results);
    }

    function setActive(el) {
      resultLinks().forEach(function (a) { a.removeAttribute('data-active'); });
      if (el) {
        el.setAttribute('data-active', 'true');
        el.focus({ preventScroll: false });
      }
    }

    function run(term) {
      if (inFlight) inFlight.abort();
      inFlight = new AbortController();

      var url = root() + 'search/suggest?q=' + encodeURIComponent(term) +
        '&section_id=predictive-search' +
        '&resources[type]=product' +
        '&resources[limit]=8' +
        '&resources[options][unavailable_products]=last';

      fetch(url, { signal: inFlight.signal })
        .then(function (r) {
          if (!r.ok) throw new Error('suggest failed');
          return r.text();
        })
        .then(function (html) {
          // The Section Rendering API wraps output in the section div; take the
          // inner markup so we do not nest a second wrapper on every keystroke.
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('.shopify-section') || doc.body;
          results.innerHTML = section.innerHTML;
          lastTerm = term;
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          // Leave the form usable — submitting it goes to the full search page.
          clearResults();
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(debounce);

      if (term.length < 2) {
        if (inFlight) inFlight.abort();
        clearResults();
        return;
      }
      if (term === lastTerm) return;

      debounce = setTimeout(function () { run(term); }, 250);
    });

    // Arrow keys walk the results; the input keeps its value so typing resumes.
    searchPanel.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = resultLinks();
      if (!links.length) return;

      e.preventDefault();
      var idx = links.indexOf(document.activeElement);

      if (e.key === 'ArrowDown') {
        setActive(idx === -1 ? links[0] : links[Math.min(idx + 1, links.length - 1)]);
      } else if (idx <= 0) {
        setActive(null);
        input.focus();
      } else {
        setActive(links[idx - 1]);
      }
    });

    // Reset on close so the next open starts clean.
    searchPanel.addEventListener('transitionend', function () {
      if (searchPanel.getAttribute('data-open') === 'false') {
        input.value = '';
        clearResults();
      }
    });

    /* The panel has nowhere to submit to. Its form kept a real action so it
       degraded to a results page; there is no results page any more, so a
       Return press runs the same query the typing already runs instead of
       navigating to a route that only bounces back here. */
    var searchForm = searchPanel.querySelector('form');
    if (searchForm) {
      searchForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var term = input.value.trim();
        if (term.length >= 2 && term !== lastTerm) run(term);
      });
    }

    /* Arriving on ?q=… — from the old /search route, from a bookmark, from a
       browser's own search box. The doorway at /search sends the query here,
       and here is where it opens. */
    (function () {
      var q = '';
      try {
        q = (new URLSearchParams(window.location.search).get('q') || '').trim();
      } catch (err) { return; }
      if (!q) return;

      input.value = q;
      panelOpen(searchPanel);
      if (q.length >= 2) run(q);

      // The query has done its job; leaving it in the bar means every reload
      // re-opens the panel over a page the reader has since scrolled.
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', window.location.pathname);
      }
    })();
  }

  /* --- sticky header ------------------------------------------------------ */

  /* The rail stays put. It used to slide away on a downward scroll, which is
     a reasonable trade when a header is decoration — but it now carries the
     whole navigation, and hiding the only way between archive, catalogue,
     search and bag is not a trade worth making. Anything sticking below it
     needs its height as an offset. */
  var header = $('[data-header]');
  if (header) {
    var setOffset = function () {
      document.documentElement.style.setProperty(
        '--sticky-offset', header.offsetHeight + 'px');
    };
    setOffset();
    window.addEventListener('resize', setOffset, { passive: true });

    /* Opaque at the top, transparent once the page has moved.

       At rest the rail is the lid on the page and needs its fill and its rule
       to be one; a scrolled page has its own subject, and a rail sitting on
       top of it in a white band is a strip of furniture in the way. The state
       is an attribute and everything it does is CSS, so the scroll handler
       writes one string and never reads layout.

       Latched rather than set per frame: the attribute only changes when the
       page crosses the threshold, so a long scroll is a handful of writes
       instead of one per frame. Read through rAF so nothing here can land in
       the middle of the browser's own scroll work. */
    var scrolled = null;
    var ticking = false;

    function drawHeader() {
      ticking = false;
      var now = window.scrollY > 4;
      if (now === scrolled) return;
      scrolled = now;
      header.setAttribute('data-scrolled', now ? 'true' : 'false');
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(drawHeader);
    }, { passive: true });

    // A reload part-way down a page starts scrolled, and the rail has to know.
    drawHeader();
  }

  /* --- categories: the rail behind the plus -------------------------------

     Two rails stacked in one slot, and a box around them whose width is the
     only thing that travels. The sequence is always the same:

       the rail on screen lets go of its items, left to right
       the box takes the width of the rail that is arriving
       that rail takes its items back, left to right

     Width has to be written as a number for it to animate at all — `auto` has
     nothing to interpolate towards — so it is measured off the rails
     themselves and rewritten on resize. The plus sits after the box rather
     than inside it, which is what makes it ride along to the end of whatever
     is showing instead of jumping there.

     The stagger is done with a transition delay per item rather than a
     keyframe per item: one class flip starts the whole row, and a browser that
     drops frames loses smoothness rather than losing the swap. */

  var swap = $('[data-nav-swap]');
  var catsToggle = $('[data-cats-toggle]');
  var primaryRail = $('[data-nav-primary]');
  var catsRail = $('[data-nav-cats]');

  if (swap && catsToggle && primaryRail && catsRail) {
    /* Halved and flattened under a finger. The stagger is a pleasure at a
       pointer, where the rail is a line of type you are watching; under a tap
       it is 340ms before anything moves and most of a second before the plus
       will answer again, which reads as a control that did not take the tap. */
    var coarse = window.matchMedia('(pointer: coarse)').matches;
    var STAGGER = coarse ? 0 : 34;    // ms between one item leaving and the next
    var SETTLE = coarse ? 150 : 260;  // matches the item transition in the stylesheet
    var catsOpen = false;
    var swapping = false;
    var pending = null;   // a press that arrived mid-swap, honoured on landing
    var closing = 0;      // the phone panel's own exit, held open while it leaves

    function items(rail) {
      // Only what is actually on screen: the categories carry a gallery link
      // that CSS drops above 700px, and a hidden item given a delay slot leaves
      // a gap in the middle of the row that does travel.
      return $$('a', rail).filter(function (a) { return a.offsetParent !== null; });
    }

    /* `back` runs the stagger from the far end instead of the near one.

       Which end it starts from is the difference between a row opening and a
       row being drawn back in. Coming out, the word nearest the plus moves
       first and the rest follow it across, so the list reads as being pulled
       out of the control. Going back the same way round, the near word leaves
       first and the far ones are left hanging in mid-air with nothing to their
       left — which reads as the row falling apart rather than retracting. From
       the far end, the last word goes first and the row gathers itself back
       into the plus in the order it came out of it. */
    function stamp(rail, step, back) {
      var d = step === undefined ? STAGGER : step;
      var row = items(rail);
      row.forEach(function (a, i) {
        var slot = back ? (row.length - 1 - i) : i;
        a.style.transitionDelay = (slot * d) + 'ms';
        /* The categories arrive on a keyframe animation rather than a
           transition — see cats-in — and an animation reads its own delay
           property. Written alongside rather than instead of, because the rail
           above still leaves on a transition and the two share this one
           routine. */
        a.style.animationDelay = (slot * d) + 'ms';
      });
    }

    /* Measured with the rail laid out but not painted: `hidden` is removed for
       one synchronous read and put straight back, so nothing flashes.

       Measured at max-content, and that is the whole of it. scrollWidth is the
       larger of the content and the box, and the box here is the width left
       over from the rail that is leaving — so closing the categories asked the
       navigation how wide it was while it was being held open at the
       categories' width, got that figure back, and the box never came in. The
       plus rides on the end of the box, so what you saw was a plus stranded out
       in the middle of the bar. */
    function railWidth(rail) {
      var wasHidden = rail.hasAttribute('hidden');
      var prevWidth = rail.style.width;

      if (wasHidden) {
        rail.style.visibility = 'hidden';
        rail.removeAttribute('hidden');
      }

      rail.style.width = 'max-content';
      var w = Math.ceil(rail.getBoundingClientRect().width);
      rail.style.width = prevWidth;

      if (wasHidden) {
        rail.setAttribute('hidden', '');
        rail.style.visibility = '';
      }
      return w;
    }

    /* Only where there is a box to fit. Below 700px the categories are a panel
       under the bar rather than a rail inside it, so there is no box, nothing
       for a width to travel towards, and a width written here would be a width
       the stylesheet then has to fight with !important. */
    function boxed() {
      return window.matchMedia('(min-width: 700px)').matches;
    }

    /* --- which document the panel belongs to --------------------------------

       Above the breakpoint the categories are a rail that shares a slot with
       the navigation, and they have to be inside that slot for the swap to
       have anything to travel between.

       Below it they are a panel dropped under the bar, and being inside the
       bar is exactly what was wrong with them: the header is held at the top
       of the window by a sticky wrapper, and everything inside it is held
       there too. The list followed the reader down the whole catalogue.

       So on a phone it is lifted out and parked immediately after the header,
       where nothing above it is positioned — which is what lets the stylesheet
       resolve it against the page rather than against the rail, and what makes
       the first scroll leave it behind. Nothing about it changes but its
       parent; it is the same element with the same listeners either way. */
    var catsHome = catsRail.parentNode;
    var headerBlock = catsToggle.closest('.shopify-section') ||
      catsToggle.closest('.header') || null;

    function placePanel() {
      if (!headerBlock || !headerBlock.parentNode) return;

      if (boxed()) {
        if (catsRail.parentNode !== catsHome) catsHome.appendChild(catsRail);
        return;
      }
      if (catsRail.parentNode !== headerBlock.parentNode ||
          catsRail.previousElementSibling !== headerBlock) {
        headerBlock.parentNode.insertBefore(catsRail, headerBlock.nextSibling);
      }
    }

    placePanel();

    function fitBox() {
      if (!boxed()) {
        swap.style.width = '';
        /* Coming down across the breakpoint with the categories open, the
           navigation is still the rail the desktop swap took out of the
           layout. On a phone the two are not alternatives — the panel opens
           under a navigation that stays put — so it comes back. */
        primaryRail.removeAttribute('hidden');
        primaryRail.removeAttribute('data-out');
        return;
      }
      /* And going back up with them open, the navigation has to leave again,
         because up here the pair really are alternatives sharing one slot. */
      if (catsOpen) primaryRail.setAttribute('hidden', '');
      swap.style.width = railWidth(catsOpen ? catsRail : primaryRail) + 'px';
    }

    function showCats(open) {
      if (open === catsOpen) return;

      /* On a phone this is a disclosure, not a swap. The categories are a panel
         under the bar, so the navigation above it has no reason to leave — and
         with nothing leaving there is nothing to stagger and nothing to wait
         for, which is also what makes the plus answer a tap in one frame.

         Returns before `swapping` is set: there is no travel to protect, and
         holding the control shut for the length of an animation that is not
         running is the thing that made it feel unresponsive in the first
         place. */
      if (!boxed()) {
        catsOpen = open;
        catsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        primaryRail.removeAttribute('hidden');
        swap.style.width = '';

        if (!open) {
          /* Out the way it came in. It used to be hidden on the spot, which is
             why the list appeared to open and then simply cease to exist —
             `hidden` is display:none and there is nothing left to animate.

             So the leaving state goes on first and the element is held in the
             layout for as long as the last word needs to finish, then hidden.
             The timer is kept because a reader who presses the plus twice in
             under half a second would otherwise have the panel taken away
             underneath the opening it just asked for. */
          window.clearTimeout(closing);
          stamp(catsRail, 34, true);
          catsRail.setAttribute('data-out', 'true');

          /* Held for the length of the exit the stylesheet actually runs —
             340ms a word, the mirror of the arrival — plus the last word's
             delay. The exit used to run at the rail's quick 150ms against an
             arrival at 340, and the mismatch is what read as the panel
             glitching shut instead of leaving the way it came. */
          var rows = items(catsRail).length;
          closing = window.setTimeout(function () {
            catsRail.setAttribute('hidden', '');
            catsRail.removeAttribute('data-out');
          }, 340 + (rows * 34));
          return;
        }

        // Re-opened mid-exit: the panel is still in the layout and must not be
        // hidden by a timer that belongs to a gesture already overtaken.
        window.clearTimeout(closing);

        /* The rows come down one after another. A stagger of its own rather
           than the row's, which is zero under a finger so the plus can answer
           in a frame: nothing is waiting on this one — the panel is already
           in the layout and the toggle is already free — so it can afford to
           read as a list arriving rather than a block appearing. */
        catsRail.removeAttribute('hidden');
        /* The rail's own stagger, which is what makes the row leave and land
           left to right up there. Written as the figure rather than read from
           STAGGER, because that one is zeroed under a finger so the plus can
           answer in a frame — and nothing is waiting on this one. */
        stamp(catsRail, 34);

        /* Cleared, not set and released a frame later. The arrival here is a
           keyframe animation — see cats-in — and an animation plays the moment
           the element is drawn, so it needs no previous value and no held-back
           frame. It used to be set to the leaving state and freed inside a
           double requestAnimationFrame, which meant the whole opening hung on
           two frames arriving: in a background tab, on a throttled phone, or
           any time the browser had stopped painting, they never came and the
           panel sat at zero opacity with the minus already showing. Clearing
           it is also what an overtaken exit needs — the attribute is still on
           the element from a close that never finished. */
        catsRail.removeAttribute('data-out');
        return;
      }

      /* A press during the swap is remembered rather than dropped. The rail is
         a second of travel with eight categories on it, and a plus that
         ignores the hand on it for that second is a plus that is broken —
         whatever was asked for last is what the rail settles on. */
      if (swapping) {
        pending = open;
        return;
      }

      swapping = true;
      pending = null;

      /* The glyph answers the press, not the rail. It used to be turned over
         at the far end of the leaving stagger, which left the control sitting
         as a minus for half a second after it had been told to close. */
      catsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');

      var leaving = open ? primaryRail : catsRail;
      var arriving = open ? catsRail : primaryRail;

      stamp(leaving);
      leaving.setAttribute('data-out', 'true');

      var out = items(leaving).length * STAGGER + SETTLE;

      window.setTimeout(function () {
        catsOpen = open;

        leaving.setAttribute('hidden', '');
        leaving.removeAttribute('data-out');
        arriving.removeAttribute('hidden');

        /* Arrive held back, then released once the held-back state has actually
           been computed — a transition needs a previous value to travel from,
           and an element unhidden and released in one go simply appears.

           The read of offsetWidth is what forces that computation. It used to
           be two nested requestAnimationFrames, which is the same idea told to
           the compositor rather than to the layout engine: correct while the
           page is painting, and silently nothing when it is not. A tab in the
           background stops getting frames, the callbacks never run, and the
           rail that was meant to arrive stays at zero opacity for as long as
           you are looking elsewhere. A forced reflow costs one layout and
           cannot be skipped. */
        arriving.setAttribute('data-out', 'true');
        stamp(arriving);
        swap.style.width = boxed() ? railWidth(arriving) + 'px' : '';

        void arriving.offsetWidth;
        arriving.removeAttribute('data-out');

        window.setTimeout(function () {
          swapping = false;
          if (pending !== null && pending !== catsOpen) showCats(pending);
          pending = null;
        }, items(arriving).length * STAGGER + SETTLE);
      }, out);
    }

    catsToggle.addEventListener('click', function () {
      showCats(!catsOpen);
    });

    // Closing on Escape costs one listener and saves a reader who opened the
    // rail with a keyboard from having to tab back to the plus.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && catsOpen && !openPanel) showCats(false);
    });

    /* Tapping off the row no longer shuts it.

       That gesture belongs to a panel hanging over the page: something is
       covered, so anywhere you press means put it away. This row covers
       nothing — it stands in the page and the goods start under it — so a
       stray press on a card had the filters folding away behind a reader who
       was only looking at a garment, and the minus, which is the control that
       says what it does, was never the thing that closed them.

       One control, one meaning: the plus opens the row and the minus shuts
       it. Escape above still does too, for a keyboard. */

    fitBox();
    window.addEventListener('resize', function () {
      // Before the measuring: which parent the panel is in decides whether it
      // has a box to be fitted to at all, and a phone turned on its side
      // crosses the breakpoint that answers that.
      placePanel();
      if (!swapping) fitBox();
    }, { passive: true });

    // Fonts land after first paint and every one of these measurements is a
    // string of type, so the box is remeasured once the face is in.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { if (!swapping) fitBox(); });
    }

    /* --- filtering the catalogue in place --------------------------------

       The whole catalogue is already on the page, so a category is a class
       flip — nothing is fetched, nothing re-renders, and the grid never loses
       its place. What the cards then do is measured off yeezy.com rather than
       invented: see flip() below.

       The catalogue and not the archive. The archive reads by date and a
       filter that empties four of its six drops has taken a chronology apart;
       this is the page that exists to be looked through by kind. */
    /* The header outlives every page under it now — see the router — so none of
       this may close over a grid. It is looked up on each pass and the listeners
       below are bound once, to the rail, which is the thing that stays. */
    var grid = null;
    var current = '';
    var watcher = null;

    function paint(handle) {
      if (!grid) return;

      // Re-read every pass: the catalogue runs on as it is scrolled, so the
      // grid this filters is longer than it was the last time round.
      var cards = $$('.card[data-category]', grid);

      var live = 0;
      cards.forEach(function (card) {
        var hit = !handle || card.getAttribute('data-category') === handle;
        card.hidden = !hit;
        if (hit) live += 1;
      });

      grid.setAttribute('data-filter', handle);
      grid.setAttribute('data-empty', live === 0 ? 'true' : 'false');
    }

    function apply(handle, animate) {
      current = handle;

      $$('a[data-cat]', catsRail).forEach(function (a) {
        if ((a.getAttribute('data-cat') || '') === handle) {
          a.setAttribute('aria-current', 'true');
        } else {
          a.removeAttribute('aria-current');
        }
      });

      if (!grid) return;

      if (!animate ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        paint(handle);
        return;
      }

      flip(handle);
    }

    /* --- the swap, as the shop it is modelled on actually runs it -----------

       Measured rather than guessed at, and the guess was wrong twice before
       this. A filter on yeezy.com puts exactly one thing on the page: a
       transform transition on every tile that survives it — 200ms, on
       cubic-bezier(0.22, 1, 0.36, 1) — and nothing whatever on the tiles that
       go. They do not fade out and the survivors do not fade in. The survivors
       travel, from the positions they were standing in to the ones the shorter
       grid gives them, and that travel is the entire effect. A crossfade in
       its place is a different animation that happens to take the same length
       of time: the grid is redrawn rather than rearranged, and nothing on
       screen connects what was there to what is there now.

       FLIP, which is the only way to animate a layout the browser is doing for
       you: read where everything is (First), change the layout (Last), put
       everything back where it was with a transform (Invert), then let go
       (Play). Every card animates one compositor property and the grid itself
       is never laid out again while it runs.

       Run slower than the shop it was measured from, which is a deliberate
       departure. 200ms is right for a grid of small tiles travelling a short
       way; the cards here are 4:5 packshots two or three to a row, so the same
       gesture covers a lot more screen and at 200ms it is over before the eye
       has followed any single card to where it went — which reads as the grid
       having jumped rather than moved. 300 is long enough to see a card arrive
       and still short enough not to be a wait. The curve is unchanged: it does
       almost all of its distance early and settles, so the extra hundred
       milliseconds land in the settling rather than in the travel. */
    var FLIP_MS = 300;
    var FLIP_EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
    var settling = 0;

    function flip(handle) {
      var cards = $$('.card[data-category]', grid);

      // FIRST — where every card on screen is standing, before anything moves.
      var was = cards.map(function (card) {
        return card.hidden ? null : card.getBoundingClientRect();
      });

      // LAST — the new set, laid out. Synchronously, because the reads below
      // have to see the finished layout and not the one being left.
      paint(handle);

      // INVERT — each survivor put back where it was.
      var moved = [];
      cards.forEach(function (card, i) {
        if (card.hidden) return;

        card.style.transition = 'none';

        if (!was[i]) {
          /* It was not on screen a moment ago, so there is no position for it
             to come from and a transform has nothing to say. It fades instead
             — the one place this departs from what was measured, and only
             because these frames load late: a packshot that arrives at full
             strength before its image has decoded reads as a hole in the
             grid. */
          card.style.opacity = '0';
          moved.push(card);
          return;
        }

        var now = card.getBoundingClientRect();
        var dx = was[i].left - now.left;
        var dy = was[i].top - now.top;
        // A card that did not move needs no animation, and giving it one costs
        // a compositor layer for a card that is standing still.
        if (!dx && !dy) return;

        card.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
        moved.push(card);
      });

      if (!moved.length) return;

      /* PLAY — one forced layout, so the held-back state is a real computed
         style and not a pair of writes the browser is free to collapse into
         one. A reflow rather than a requestAnimationFrame: rAF is a promise
         kept only while the page is painting, and a filter pressed in a
         background tab would otherwise leave every card sitting at its old
         position for as long as nobody was looking. */
      void grid.offsetWidth;

      moved.forEach(function (card) {
        card.style.transition = 'transform ' + FLIP_MS + 'ms ' + FLIP_EASE +
          ', opacity ' + FLIP_MS + 'ms ' + FLIP_EASE;
        card.style.transform = '';
        card.style.opacity = '';
      });

      /* Cleared afterwards, or every card carries a transition for the rest of
         the visit and the next thing to touch one animates for no reason. One
         timer for the whole grid rather than a listener per card: the cards
         outlive this run and a listener each is a leak that grows with the
         catalogue. */
      window.clearTimeout(settling);
      settling = window.setTimeout(function () {
        moved.forEach(function (card) { card.style.transition = ''; });
      }, FLIP_MS + 60);
    }

    /* Reconcile the rail against what is actually on the page. The Liquid that
       built it can only see the first fifty products, so a large catalogue may
       leave a category out — and a collection setting may leave one in with
       nothing under it.

       Hidden rather than removed, which it used to be. The rail is now the same
       rail on every page of the visit: a category taken out of it because the
       archive did not happen to have one would never come back when the reader
       returned to the catalogue that did. */
    function reconcile() {
      var present = {};
      if (grid) {
        $$('.card[data-category]', grid).forEach(function (c) {
          present[c.getAttribute('data-category')] = true;
        });
      }

      $$('a[data-cat]', catsRail).forEach(function (a) {
        var handle = a.getAttribute('data-cat');
        if (!handle) return;                       // ALL is never dropped
        if (!grid || present[handle]) a.removeAttribute('hidden');
        else a.setAttribute('hidden', '');
        delete present[handle];
      });

      // The catalogue is the page being filtered, so a bare query is the whole
      // link — it resolves against whatever path it is served at.
      Object.keys(present).forEach(function (handle) {
        if (!handle) return;
        var a = document.createElement('a');
        a.className = 'underline-hover';
        a.href = '?c=' + encodeURIComponent(handle);
        a.setAttribute('data-cat', handle);
        a.textContent = handle.replace(/-/g, ' ').toUpperCase();
        catsRail.appendChild(a);
      });

      fitBox();
    }

    /* Called at boot and again by the router every time a new page lands under
       the header. Everything that belongs to a page — the grid, the observer
       watching it, the category the URL is asking for — is rebuilt here;
       everything that belongs to the rail was bound once, below. */
    function bindGrid() {
      if (watcher) { watcher.disconnect(); watcher = null; }

      grid = $('[data-filterable]');
      current = '';
      reconcile();

      if (!grid) {
        // Nothing on this page to filter, so nothing in the rail is current.
        $$('a[data-cat]', catsRail).forEach(function (a) {
          a.removeAttribute('aria-current');
        });
        return;
      }

      /* The catalogue runs on as it is scrolled, and pages that arrive after a
         filter is set have to arrive filtered. Watching the grid is cheaper
         than teaching the infinite scroll about categories, and it cannot be
         forgotten the next time that code changes. */
      if (window.MutationObserver) {
        watcher = new MutationObserver(function (records) {
          if (!current) return;
          var added = records.some(function (r) { return r.addedNodes.length > 0; });
          if (added) paint(current);
        });
        watcher.observe(grid, { childList: true });
      }

      // Landing on ?c=… — from a product page, a shared link, a back button.
      var q = '';
      try {
        q = (new URLSearchParams(window.location.search).get('c') || '').trim();
      } catch (err) { q = ''; }
      if (!q) return;

      apply(q, false);
      /* The rail opens on the category that is showing, so the reader can see
         what is filtering the page they have just landed on. Not on a phone:
         there the categories are a panel over the grid, and a page that opens
         with its own goods covered up has answered a question nobody asked
         yet. */
      if (boxed()) showCats(true);
    }

    catsRail.addEventListener('click', function (e) {
      var link = e.target.closest('a[data-cat]');
      if (!link) return;

      // Only take the click when this page is the thing being filtered.
      // Anywhere else the link is a link and should behave like one — the
      // router will carry it to the catalogue and bindGrid will read the
      // category off the URL when it lands.
      if (!grid) return;

      e.preventDefault();
      var handle = link.getAttribute('data-cat') || '';
      apply(handle, true);

      var url = handle
        ? window.location.pathname + '?c=' + encodeURIComponent(handle)
        : window.location.pathname;
      routerPush(url, { c: handle });

      /* And it stays open.

         It used to shut itself here, on the argument that the list was laid
         over the goods and the answer would arrive underneath the question.
         The list is not over anything any more — it stands in the page and
         the goods begin below it — so the argument has gone, and what was
         left was a control that undid itself: press a category, watch the
         minus turn back into a plus and the row you were choosing from fold
         away. Choosing one category is rarely the end of it, and the row you
         want next is the row that just left.

         The rail is a rail at every width now. It closes when the minus is
         pressed, and not before. */
    });

    window.addEventListener('popstate', function () {
      if (!grid) return;
      var q = '';
      try {
        q = new URLSearchParams(window.location.search).get('c') || '';
      } catch (err) { q = ''; }
      apply(q, true);
    });

    // Published for the router, which has to call it after every swap.
    rebindCatalogue = bindGrid;
    bindGrid();
  }

  /* --- variant / size picker -------------------------------------------- */

  function initProduct(root) {
    if (!root) return;

    /* Scoped to whatever is holding this product rather than to the document.
       On an ordinary page that is the section and there is only one of them; in
       the sheet the one-page transition opens, the document can hold two
       products at once — the one underneath and the one laid over it — and a
       document-wide read hands the second the first one's variants. */
    var dataEl = $('[data-variant-data]', root.parentNode) || $('[data-variant-data]');
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent).variants || []; } catch (err) { variants = []; }
    }

    var input = $('[data-variant-input]', root);
    var addBtn = $('[data-add-button]', root);
    var priceEl = $('[data-price]', root);
    var buttons = $$('.size[data-variant]', root);

    function byId(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function select(id) {
      var variant = byId(id);
      if (!variant || !variant.available) return;

      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-variant') === String(id)));
      });

      if (input) input.value = variant.id;

      if (priceEl) {
        priceEl.innerHTML =
          (variant.compare_at_price ? '<s>' + variant.compare_at_price + '</s> ' : '') +
          '<span>' + variant.price + '</span>';
      }

      if (addBtn) {
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-disabled');
      }
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        select(b.getAttribute('data-variant'));
      });
    });
  }

  /* --- accordion --------------------------------------------------------- */

  function initAccordions(scope) {
    $$('[data-acc-btn]', scope).forEach(function (btn) {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var panel = btn.nextElementSibling;
        btn.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.setAttribute('data-open', String(!expanded));
      });
    });
  }

  /* --- cart -------------------------------------------------------------- */

  function refreshDrawer(openAfter) {
    var host = $('#cart-drawer-host');
    if (!host) return Promise.resolve();

    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + '?sections=cart-drawer'
      : '/?sections=cart-drawer')
      .then(function (r) {
        if (!r.ok) throw new Error('section fetch failed');
        return r.json();
      })
      .then(function (json) {
        var html = json['cart-drawer'];
        if (!html) throw new Error('no section html');
        var wasOpen = openAfter || (currentDrawer() && currentDrawer().getAttribute('data-open') === 'true');
        host.innerHTML = html;
        var drawer = currentDrawer();
        if (drawer && wasOpen) {
          // Re-open without re-locking scroll: the lock is already held.
          openPanel = drawer;
          drawer.setAttribute('data-open', 'true');
          drawer.setAttribute('aria-hidden', 'false');
          if (overlay) overlay.setAttribute('data-open', 'true');
        }
        syncCounts();
      });
  }

  function syncCounts() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () { /* counts stay as server-rendered */ });
  }

  // Add to cart — falls back to a native form submit if the request fails.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    var btn = $('[data-add-button]', form);
    e.preventDefault();

    var body = new FormData(form);
    if (btn) btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (btn) btn.disabled = false;
        if (!lockCount) lockScroll();
        return refreshDrawer(true);
      })
      .catch(function () {
        // Let the browser do it the old-fashioned way.
        if (btn) btn.disabled = false;
        form.submit();
      });
  });

  // Remove a line from the drawer.
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    var drawer = remove.closest('[data-cart-drawer]');
    if (!drawer) return;

    e.preventDefault();
    var key = remove.getAttribute('data-cart-remove');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change failed');
        return refreshDrawer(true);
      })
      .catch(function () {
        window.location.href = remove.getAttribute('href');
      });
  });


  /* --- carousel ----------------------------------------------------------- */

  function initCarousels(scope) {
    $$('.carousel-section', scope).forEach(function (section) {
      if (section.dataset.bound === 'true') return;
      section.dataset.bound = 'true';

      var track = $('[data-carousel-track]', section);
      var prev = $('[data-carousel-prev]', section);
      var next = $('[data-carousel-next]', section);
      if (!track || !prev || !next) return;

      function step() {
        var item = track.querySelector('.carousel__item');
        return item ? item.getBoundingClientRect().width : track.clientWidth * 0.8;
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        // 2px of slack: sub-pixel widths never land exactly on the boundary.
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
        // Nothing to scroll — hide the controls rather than show two dead buttons.
        var nav = $('[data-carousel-nav]', section);
        if (nav) nav.hidden = max <= 2;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { sync(); ticking = false; });
      }, { passive: true });

      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  /* --- collection: load the next page on approach ------------------------- */

  /* Enhancement only. The markup is a plain link to the next page, so with no
     script, no IntersectionObserver, or a failed request, the archive is
     still walkable — the link simply navigates instead of appending. */
  /* Held so the router can put the last one down before setting another
     watching. The pager it was watching has been taken out of the document by
     then and would never fire again, but an observer per page visited is an
     observer per page visited. */
  var infiniteIO = null;

  function initInfinite() {
    if (infiniteIO) { infiniteIO.disconnect(); infiniteIO = null; }

    var pager = $('[data-infinite]');
    var grid = $('[data-product-grid]');
    if (!pager || !grid || !('IntersectionObserver' in window)) return;

    var busy = false;

    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || busy) return;

      var link = $('[data-infinite-next]', pager);
      if (!link) return;

      busy = true;
      pager.setAttribute('data-loading', 'true');

      fetch(link.href, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var incoming = doc.querySelector('[data-product-grid]');
          if (incoming) {
            while (incoming.firstElementChild) grid.appendChild(incoming.firstElementChild);
          }

          // A parsed document has no base URL of its own, so the href has to
          // be resolved against this page rather than read back as .href.
          var nextEl = doc.querySelector('[data-infinite-next]');
          var nextHref = nextEl && nextEl.getAttribute('href');

          if (nextHref) {
            link.href = new URL(nextHref, window.location.href).toString();
          } else {
            io.disconnect();
            pager.parentNode.removeChild(pager);
          }
        })
        .catch(function () {
          // Stop auto-loading and leave the link for the reader to click.
          io.disconnect();
          pager.setAttribute('data-failed', 'true');
        })
        .then(function () {
          busy = false;
          pager.removeAttribute('data-loading');
        });
    }, { rootMargin: '800px 0px' });

    io.observe(pager);
    infiniteIO = io;
  }

  /* --- product gallery ----------------------------------------------------- */

  /* Conveniences over a native scroll-snap track — the scrolling and snapping
     are the browser's own. Without this the track still swipes, the thumbnails
     still work as anchor links to the frames, and only the arrows and the
     progress bar go missing: the arrows ship hidden and are unhidden here, so
     a dead control is never drawn. */
  /* One track per call. The product page has a single one; the gallery has a
     track per drop, all of them on the page at once, so the run below can no
     longer assume there is only ever one to find.

     Guarded against a second pass over the same track: this routine clones the
     whole run twice to make the loop endless, and the theme editor re-runs it
     on every section reload. */
  function initGallery(root) {
    $$('[data-shots]', root || document).forEach(function (stage) {
      if (stage.getAttribute('data-shots-live') === 'true') return;
      if ($$('.pdp__frame', stage).length < 2) return;

      /* Everything below measures — frame widths, offsets, where the middle
         copy of the run starts — and a track inside a closed gallery drop has
         no measurements to take. Left unflagged rather than marked done, so
         opening that drop can run this again on a track that now has a size.

         Without it the gallery's carousels came up parked at scrollLeft 0
         instead of in the middle set, which cost every one of them the frame
         to the left of the first. */
      if (stage.offsetWidth === 0) return;

      stage.setAttribute('data-shots-live', 'true');
      initShots(stage);
    });
  }

  function initShots(stage) {
    /* The run as it was authored, and the run as it is being shown. They differ
       only above the breakpoint and only when the section has asked for a cap —
       see applyLimit below. */
    var authored = $$('.pdp__frame', stage);
    var frames = authored;
    var real = frames.length;

    var viewer = stage.parentNode;
    var bar = $('[data-shots-progress]', viewer);
    var thumbs = $$('[data-shot-jump]', viewer);
    var arrows = $$('[data-shot-step]', viewer);

    var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // The three-up only exists above this width; below it the track is one
    // frame wide and nothing is scaled.
    var wide = window.matchMedia('(min-width: 700px)');
    var ticking = false;
    var synced = false;
    var settling = 0;

    /* --- the loop ----------------------------------------------------------

       On a wide screen the track carries the run three times over: a copy of
       every frame before the real ones and another after, with the reader
       parked in the middle set. That is what makes it endless in both
       directions rather than a strip with two ends — there is always a frame to
       the left of the one you are on, so the three-up is three at the first
       shot and at the last, and pressing back from the first arrives at the
       last with no jump to see.

       On a phone it is not built at all. There is no three-up there — one frame
       fills the track — so the copies buy nothing, and what they cost is a
       reader who swipes past the last photograph and is handed the first one
       again with no way to tell they have been round. A run of five photographs
       on a phone is five photographs, and it ends.

       Only the script builds the copies. With none, the markup is what it was —
       one run of real frames that scrolls and snaps and stops at the ends,
       which is both the phone's behaviour and the correct thing for a desktop
       with no script to degrade to. */
    var looped = false;
    // Flat index into the track. Looped, it starts on the first frame of the
    // middle set and is pulled back into that set after every scroll settles,
    // so it is only ever outside it for as long as one gesture lasts.
    var index = 0;

    /* --- how many shots the wide screen gets -------------------------------

       A number on the stage, or nothing, in which case every shot is shown at
       every width and none of this does anything.

       It applies above the breakpoint only, and it is the same reason the loop
       does: up there the viewer is a three-up plate and the run is something
       you step through with two arrows, so a product photographed eight times
       is eight presses of an arrow to get back to where you started. On a phone
       the run is a swipe and a swipe is cheap — five photographs there are five
       flicks of a thumb, in the gesture the reader was already making.

       Hidden rather than removed: the same element has to come back when the
       phone is turned on its side, and a frame taken out of the document is a
       frame whose image has to be fetched again. */
    var wideMax = parseInt(stage.getAttribute('data-wide-max'), 10) || 0;

    function applyLimit(on) {
      var n = on && wideMax ? Math.min(wideMax, authored.length) : authored.length;

      authored.forEach(function (frame, i) {
        if (i < n) frame.removeAttribute('hidden');
        else frame.setAttribute('hidden', '');
      });

      // The contact sheet under the plate is one thumbnail per frame, so it
      // answers to the same cap — a thumbnail pointing at a frame that is not
      // in the track is a control that does nothing.
      thumbs.forEach(function (thumb, i) {
        if (i < n) thumb.removeAttribute('hidden');
        else thumb.setAttribute('hidden', '');
      });

      real = n;
    }

    function buildLoop() {
      applyLimit(true);

      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();

      frames = authored.slice(0, real);

      frames.forEach(function (frame, i) {
        [before, after].forEach(function (bucket, side) {
          var copy = frame.cloneNode(true);
          // The id is the anchor the no-script thumbnails point at, and an id
          // repeated three times down the page belongs to whichever copy came
          // first — which would not be the real one.
          copy.removeAttribute('id');
          copy.setAttribute('data-clone', 'true');
          // Announced once, by the frame the reader can actually reach.
          copy.setAttribute('aria-hidden', 'true');

          // The last copy before the run is the frame you land on the moment
          // you press back from the first shot, so it is the one clone that
          // cannot afford to still be loading when it arrives. The rest come
          // into view by scrolling, which is what lazy loading is for.
          if (side === 0 && i === real - 1) {
            var eager = $('img', copy);
            if (eager) {
              eager.setAttribute('loading', 'eager');
              eager.removeAttribute('fetchpriority');
            }
          }

          bucket.appendChild(copy);
        });
      });

      stage.insertBefore(before, stage.firstChild);
      stage.appendChild(after);
      // Capped frames sit in the document between the run and the copies after
      // it, out of the layout. They must stay out of this list too, or every
      // index past the cap points at a frame with no position.
      frames = $$('.pdp__frame:not([hidden])', stage);
      looped = true;
    }

    function dropLoop() {
      $$('.pdp__frame[data-clone]', stage).forEach(function (copy) {
        copy.parentNode.removeChild(copy);
      });
      applyLimit(false);
      frames = $$('.pdp__frame:not([hidden])', stage);
      looped = false;
    }

    /* A phone turned on its side crosses 700px, and the track it lands on has
       to be the one that width is owed. Returns whether anything changed, so
       the caller knows the geometry underneath it has been rebuilt. */
    function syncLoop() {
      if (wide.matches === looped) return false;
      if (wide.matches) buildLoop();
      else dropLoop();
      index = looped ? real : 0;
      synced = false;
      return true;
    }

    syncLoop();

    /* Tells the stylesheet to stop transitioning the frames: their size is
       driven per scroll frame now, and a transition on top of that would run a
       280ms lag behind the finger. The CSS keeps its own class-based version
       for the case where none of this executes. */
    stage.setAttribute('data-live', 'true');

    /* --- geometry, measured once ------------------------------------------

       Every frame sits at a fixed offset decided by the flex layout, so none
       of this changes while the track is being scrolled — only when the window
       resizes or the breakpoint flips. Reading it per scroll frame was the
       single most expensive thing this gallery did: offsetLeft and offsetWidth
       are reads, they were interleaved with style writes in the same loop, and
       every read after a write forces the browser to lay the page out again on
       the spot. Five frames meant five synchronous layouts per frame of
       animation, which is exactly what a stuttering scroll feels like. */
    var metrics = [];
    var halfView = 0;
    var maxScroll = 0;
    var scaled = false;

    function measure() {
      // offsetLeft is measured from the offsetParent — the viewer, not the
      // stage — so the viewer's own offset comes back out to leave a figure in
      // the track's scroll coordinates, which is what scrollLeft speaks.
      var origin = stage.offsetLeft;
      metrics = frames.map(function (frame) {
        return {
          centre: frame.offsetLeft - origin + frame.offsetWidth / 2,
          width: frame.offsetWidth
        };
      });
      halfView = stage.clientWidth / 2;
      maxScroll = stage.scrollWidth - stage.clientWidth;

      var nowScaled = wide.matches;
      if (scaled && !nowScaled) {
        // Dropped below the breakpoint: hand the frames back to the stylesheet.
        frames.forEach(function (frame) {
          frame.style.transform = '';
          frame.style.opacity = '';
        });
      }
      scaled = nowScaled;
    }

    /* Which frame is in view is a question of proximity, not arithmetic: the
       frames are not all the same width once one of them is a square, and a
       flick can leave the track between two snap points. */
    function nearest(mid) {
      var best = 0;
      var bestGap = Infinity;

      for (var i = 0; i < metrics.length; i++) {
        var gap = Math.abs(metrics[i].centre - mid);
        if (gap < bestGap) {
          bestGap = gap;
          best = i;
        }
      }
      return best;
    }

    /* The run is a loop: left from the first shot lands on the last, right from
       the last comes back to the first. A gallery of five photographs has no
       beginning to be at, and an arrow that stops answering at either end is
       the reader finding out where the run happened to be cut.

       Modulo written the long way because JavaScript's own keeps the sign of
       the left operand: -1 % 5 is -1, not 4. */
    /* One step is always one frame along the tripled track: the middle set has
       a full copy either side of it, so index ± 1 is a real neighbour from
       every position the reader can be parked at.

       What it must never do is nothing. This used to clamp the step into the
       track's range, which turned a press off either end into a scroll to
       where the track already was — invisible from the reader's side, and
       indistinguishable from a broken control. It only ever bit on the first
       press after landing on a product, because that is the one moment the
       track can be sitting at flat zero: a stage whose opening scrollLeft was
       clamped, or one whose copies were never built, is parked on the first
       frame with nothing to its left, and left from there had nowhere to go.
       Pressing right once moved it off zero and every press after that worked,
       which is exactly how it was reported.

       So a step out of range is answered rather than swallowed. Looped, the
       middle set is pulled back under the reader first — the frame on screen
       and both its neighbours are the same photographs before and after, so
       there is nothing to see — and the step is taken from there, where a
       neighbour is guaranteed in both directions. Unlooped there is no middle
       set to come back to and the two ends are real, so it wraps: the last
       shot is what lies to the left of the first, which is what calling the
       run a loop meant in the first place. */
    /* Take the brakes off a frame before travelling to it.

       Everything past the opening three is lazy, which is right for a run of
       eight photographs nobody may look at — and wrong for the one that is
       about to arrive, because a lazy image does not begin loading until it is
       nearly in view, and "nearly in view" happens at the end of the scroll
       rather than at the start of it. The wait after pressing an arrow was that
       gap: the travel and the fetch running one after the other instead of
       together.

       Cleared on the way out, for the target and its neighbours — the next
       press is as likely to continue as to come back. Setting loading="eager"
       on an image already in the document starts the fetch immediately; on one
       already fetched it does nothing at all, so this is safe to run on every
       press without keeping track of what has been done. */
    function warm(i) {
      var n = frames.length;
      if (!n) return;
      [i - 1, i, i + 1].forEach(function (k) {
        var frame = frames[((k % n) + n) % n];
        if (!frame) return;
        var img = $('img', frame);
        if (img && img.getAttribute('loading') === 'lazy') {
          img.setAttribute('loading', 'eager');
        }
      });
    }

    function goTo(i) {
      var last = metrics.length - 1;
      if (last < 0) return;

      warm(i);

      var target = i;
      if (target < 0 || target > last) {
        if (looped && pullBack()) {
          target = nearest(stage.scrollLeft + halfView) + (i < 0 ? -1 : 1);
        }
        target = ((target % metrics.length) + metrics.length) % metrics.length;
      }

      var left = metrics[target].centre - halfView;

      /* Older Safari ignores the options form of scrollTo outright rather than
         falling back to an instant jump, which would leave the arrows looking
         dead. Assigning scrollLeft always moves something. */
      if (smooth && 'scrollBehavior' in document.documentElement.style) {
        stage.scrollTo({ left: left, behavior: 'smooth' });
      } else {
        stage.scrollLeft = left;
        // A travelling scroll repaints off its own scroll events; a jump does
        // not reliably produce one, so the arrival is drawn here instead.
        draw();
      }
    }

    /* Back into the middle set, by exactly the distance between one set and
       the next. The frame the reader is looking at and the frames either side
       of it are identical before and after — same photographs, same order, same
       offset from the centre — so there is nothing on screen to give it away.

       Only ever run on a track that has stopped moving. Rewriting scrollLeft
       under a scroll in flight is what a jump would look like. */
    /* The move itself, with no opinion about whether now is a good moment for
       it. Split out because the two callers want opposite things: the settle
       below will only ever do this to a track that has stopped, and goTo wants
       it done on the spot — a press that has nowhere to step is a press that
       cannot afford to wait for a timer. Reports whether it moved anything, so
       the caller knows if the position it is about to read has changed. */
    function pullBack() {
      if (!looped || !metrics.length) return false;

      index = nearest(stage.scrollLeft + halfView);
      var logical = ((index % real) + real) % real;
      var target = real + logical;
      if (target === index || !metrics[target]) return false;

      stage.scrollLeft += metrics[target].centre - metrics[index].centre;
      index = target;
      synced = false;
      draw();
      return true;
    }

    function recentre() {
      // Nothing to come back to on a track with one copy of the run on it.
      if (!looped || !metrics.length) return;

      var here = nearest(stage.scrollLeft + halfView);
      var parked = metrics[here].centre - halfView;

      /* Only ever on a track that has come to rest on a frame. The settle timer
         says "no scroll event for a while", which is not the same thing: a
         press landing in that gap starts a new travel, and rewriting scrollLeft
         underneath it both cancels the press and shows the seam. Off by more
         than a pixel from a snap point means still moving — try again once it
         is not. */
      if (Math.abs(stage.scrollLeft - parked) > 1.5) {
        settle();
        return;
      }

      pullBack();
    }

    /* --- per frame: writes only -------------------------------------------

       Nothing in here reads layout. scrollLeft is taken once at the top, and
       everything after it is arithmetic on the cached measurements followed by
       transform and opacity — the two properties a compositor can handle
       without laying the page out or repainting it. */
    function paint(mid) {
      if (bar) {
        /* Measured across the middle set alone, not the tripled track: the bar
           says which of five photographs you are on, and the two copies either
           side of them are the same five. Clamped, because a gesture is
           allowed to carry the reader into a copy for a moment before the
           track is pulled back. */
        var first = looped ? real : 0;
        var last = looped ? real * 2 - 1 : real - 1;
        var span = metrics[last].centre - metrics[first].centre;
        var travelled = span > 0 ? (mid - metrics[first].centre) / span : 0;
        travelled = Math.max(0, Math.min(1, travelled));
        // One frame in is already 1/count of the way through, not zero.
        bar.style.transform =
          'scaleX(' + ((1 + travelled * (real - 1)) / real) + ')';
      }

      if (!scaled) return;

      for (var i = 0; i < frames.length; i++) {
        // 0 at the centre, 1 a full frame away, clamped beyond that.
        var away = Math.min(1, Math.abs(metrics[i].centre - mid) / metrics[i].width);
        frames[i].style.transform = 'scale(' + (1 - away * 0.45) + ')';
        frames[i].style.opacity = String(1 - away * 0.45);
      }
    }

    /* --- on arrival: attributes -------------------------------------------

       Only when the frame you are on actually changes. Writing the same
       attribute value on twelve elements sixty times a second invalidates
       their style on every one of those writes for no visible result, and the
       greyness of the neighbours belongs here rather than in paint: a filter
       whose value moves every frame cannot be cached and repaints the whole
       photograph each time. As a state it is computed once per arrival. */
    function sync(mid) {
      var next = nearest(mid);
      if (next === index && synced) return;
      index = next;
      synced = true;

      frames.forEach(function (frame, i) {
        frame.setAttribute('data-active', String(i === index));
      });

      // Against the photograph, not the copy of it: three flat frames answer
      // to every thumbnail, and only the position in the run is a thing the
      // reader can see.
      var showing = ((index % real) + real) % real;
      thumbs.forEach(function (thumb, i) {
        thumb.setAttribute('aria-current', String(i === showing));
      });

      /* No spent state, at either end, looped or not. Looped the track wraps
         through its copies; unlooped goTo wraps through the run itself. Both
         arrows now lead somewhere from every frame there is, so marking one
         disabled would be describing a control that works as one that does
         not — and the stylesheet has never drawn that state anyway. */
      arrows.forEach(function (arrow) {
        arrow.removeAttribute('aria-disabled');
      });
    }

    function draw() {
      // The one layout read of the frame, taken before any write.
      var mid = stage.scrollLeft + halfView;
      paint(mid);
      sync(mid);
    }

    function remeasure() {
      // Before the measuring, because crossing 700px adds or removes two thirds
      // of the frames there are to measure.
      syncLoop();
      measure();
      // Every offset in the track has just changed, and scrollLeft is a figure
      // in the old geometry — held to the frame the reader is on rather than
      // to a number that now points somewhere else.
      if (metrics[index]) stage.scrollLeft = metrics[index].centre - halfView;
      synced = false;
      schedule();
    }

    function schedule() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        // Cleared before the work, not inside it: if draw ever throws, the
        // flag must not be left set or every later scroll is swallowed.
        ticking = false;
        draw();
      });
    }

    arrows.forEach(function (arrow) {
      arrow.hidden = false;
      /* Stepped from where the track actually is, not from where the last
         paint recorded it. index is written by a requestAnimationFrame that a
         browser is entitled to skip, and a press landing in one of those gaps
         used to step from a stale frame — most visibly straight after a
         recentring, where it read as the arrow doing nothing at all. The
         position is the one source that cannot be out of date. */
      arrow.addEventListener('click', function () {
        /* A desktop track with no copies on it is the other way a press lands
           on nothing — one run, parked on its first frame, with the left half
           of the three-up simply absent. It is supposed to be impossible after
           boot, and the moment a reader presses an arrow is the moment it has
           to actually be true, so the mismatch is repaired here rather than
           trusted. Costs a comparison per press when there is nothing wrong. */
        if (wide.matches !== looped) remeasure();

        var from = nearest(stage.scrollLeft + halfView);
        goTo(from + Number(arrow.getAttribute('data-shot-step')));
      });
    });

    /* --- the picture as the control ----------------------------------------

       Where the viewer asks for it, a press on the photograph steps the run
       on. The gallery does: its frame is the width of the page, so a pair of
       triangles would sit on top of the only thing the page is for, and the
       obvious thing to press is the picture itself.

       Only a press, never the end of a drag. A scroll-snap track is dragged
       with a mouse as well as swiped, and a gesture that moved the track is a
       gesture that has already done what it meant to — stepping it again on
       release would take the reader two frames for one movement. Six pixels
       is the slack a hand has while pressing a button.

       Right-hand side goes on, left comes back, which is the shape of the
       arrows it replaces without drawing them. */
    if (viewer && viewer.hasAttribute && viewer.hasAttribute('data-step-on-click')) {
      var pressAt = null;

      stage.addEventListener('pointerdown', function (e) {
        pressAt = { x: e.clientX, y: e.clientY, left: stage.scrollLeft };
      }, { passive: true });

      stage.addEventListener('click', function (e) {
        if (!pressAt) return;
        var moved = Math.abs(e.clientX - pressAt.x) > 6 ||
          Math.abs(e.clientY - pressAt.y) > 6 ||
          Math.abs(stage.scrollLeft - pressAt.left) > 6;
        pressAt = null;
        if (moved) return;

        var box = stage.getBoundingClientRect();
        var back = e.clientX < box.left + box.width / 2;
        var from = nearest(stage.scrollLeft + halfView);
        goTo(from + (back ? -1 : 1));
      });
    }

    /* The thumbnails are real anchors to the frames, which is what makes them
       work with no script. Taking the click back gets the same scroll without
       stamping a hash onto the URL or jolting the page to the track's top. */
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        // The thumbnails name photographs; a looped track holds three copies
        // of each. The one in the middle set is the one to travel to — from
        // there every neighbour is a real frame in both directions.
        goTo(looped ? real + i : i);
      });
    });

    measure();
    // Parked in the middle set before the first paint, so a looped run opens
    // with a frame either side of the one it opens on. Unlooped it opens where
    // it starts, which is the first photograph.
    stage.scrollLeft = metrics[index].centre - halfView;
    draw();

    /* Did the parking take?

       A track is measured the instant it is built, and that instant is not
       always one where the track has its final size. The router fills the
       product sheet while it is still off the bottom of the window; a gallery
       drop is measured in the same frame it stops being display:none. A stage
       that is not laid out yet reports a scrollWidth it has not got, and the
       browser quietly clamps an opening scrollLeft that overruns it — landing
       the reader on flat zero, which is the first frame of the first copy with
       nothing to its left at all.

       Asked as a question about the track, not about `index`. The clamped
       assignment fires a scroll event of its own, and the frame that answers
       it runs sync and rewrites index to wherever the track actually ended up
       — so by the time this runs, index agrees with the wrong position and
       comparing the two would always pass. Where the reader is supposed to be
       is anywhere in the middle set; where they must not be left is a copy.

       And a gallery drop does it for a second reason, which is the one that
       actually bit: a box going from display:none to display:block has its
       scroll position reset to zero by the browser, at the layout that first
       draws it. The drop is revealed and the track is parked in the same task,
       so the parking is written before that layout and thrown away by it.

       Two frames, not one. A requestAnimationFrame callback runs before the
       layout of the frame it belongs to — early enough to be undone by exactly
       the reset this is here to answer. The second one lands after it, which
       is the first moment the track's position is the browser's final word on
       the subject rather than a value still to be overwritten.

       There is no later event to catch any of this on: the document loaded
       long ago and the window never resized. */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (!looped || !metrics.length) return;

        var here = nearest(stage.scrollLeft + halfView);
        if (here >= real && here < real * 2) return;

        // Measured again first: if the parking was clamped rather than reset,
        // the geometry it was computed from was wrong, and pulling back on
        // stale figures only moves the reader to a different wrong frame.
        measure();
        pullBack();
      });
    });

    /* The settle, and the only place the track is ever pulled back into the
       middle set. Every scroll — a press, a swipe, a trackpad flick — ends in
       one of these, whether or not the browser has scrollend. */
    function settle() {
      window.clearTimeout(settling);
      settling = window.setTimeout(recentre, 140);
    }

    stage.addEventListener('scroll', function () {
      schedule();
      settle();
    }, { passive: true });
    window.addEventListener('resize', remeasure, { passive: true });
    // Frames are sized by flex-basis, so a late-decoding photograph does not
    // move them — but a late webfont or a scrollbar appearing does.
    window.addEventListener('load', remeasure);

    /* The settle. Every mid-scroll update goes through requestAnimationFrame,
       which a browser is entitled to starve — a backgrounded tab gets no
       frames at all — and a scroll that ends during one of those gaps leaves
       the wrong frame marked as the one you are on. scrollend fires once the
       track has actually stopped, and calls draw straight out, so the final
       state is correct whatever happened to the frames in between. */
    if ('onscrollend' in window) {
      stage.addEventListener('scrollend', function () {
        draw();
        recentre();
      }, { passive: true });
    }
    // Crossing 700px changes whether the frames are scaled at all, and a
    // resize alone does not always fire while a window is being dragged.
    if (wide.addEventListener) wide.addEventListener('change', remeasure);
  }

  /* --- newsletter popup ---------------------------------------------------- */

  /* Timing and memory only. The form inside is Shopify's own and submits on
     its own; nothing here decides whether it works, only when it is shown. */
  /* --- the popup frame takes its shape from the picture in it ---------------

     The section writes the ratio into --popup-ar from the image object Shopify
     hands it, which works for anything chosen in Customize. It cannot work for
     the plate packaged with the theme: an asset is a file, not an image object,
     so there is nothing to ask for its dimensions and the section states 700x1100
     by hand — correct for the file shipped, wrong the moment somebody replaces
     it. Swap a landscape campaign frame in and the picture is letterboxed inside
     a portrait box, which is the black band above and below it.

     Measured here instead. The browser is the one thing that always knows: it
     has the file. --popup-ar-active is written from the natural size of whatever
     the <picture> actually chose, so this is right for the packaged plate, for a
     replaced plate, for a Customize upload, and for a phone and a desktop being
     handed two different files — and it needs no dimensions written anywhere.

     On load rather than at boot, because the image is lazy and the popup starts
     hidden: there is no natural size to read until it has arrived. Re-read on
     every load, so crossing the breakpoint onto the other source re-measures. */
  function fitPopupFrame() {
    var img = $('.popup__img');
    if (!img) return;

    var media = img.parentNode;
    while (media && media.className.indexOf('popup__media') === -1) media = media.parentNode;
    if (!media) return;

    function apply() {
      if (!img.naturalWidth || !img.naturalHeight) return;
      media.style.setProperty('--popup-ar-active', img.naturalWidth / img.naturalHeight);
    }

    if (img.complete) apply();
    img.addEventListener('load', apply);
  }

  function initNewsletterPopup() {
    var popup = $('[data-newsletter-popup]');
    if (!popup) return;

    fitPopupFrame();

    var KEY = 'ks-newsletter-dismissed';
    var days = Number(popup.getAttribute('data-remember-days')) || 30;
    var delay = Number(popup.getAttribute('data-delay')) || 0;

    function remember() {
      try {
        localStorage.setItem(KEY, String(Date.now()));
      } catch (e) { /* private mode — it will ask again, which is the safe
                       direction to fail in for a thing you can close */ }
    }

    function dismissedRecently() {
      try {
        var at = Number(localStorage.getItem(KEY));
        if (!at) return false;
        return (Date.now() - at) < days * 86400000;
      } catch (e) {
        return false;
      }
    }

    /* Dial code and number are two controls and one answer. Shopify wants the
       answer, so they are joined on the way out rather than posted apart.

       Only ever additive: a number already carrying a country code is left
       exactly as typed, which is also what happens with no script at all. That
       is why the select has no name — nothing here can turn a number the
       reader typed correctly into one they did not. */
    var dial = $('[data-dial]', popup);
    var phone = $('[data-phone]', popup);

    /* The code shown in the field is type, not the select — so it is what has
       to be rewritten when the reader picks a different country. Printed by
       Liquid to begin with, which is why a page with no script still shows the
       right one rather than an empty cell. */
    var dialLabel = $('[data-dial-label]', popup);
    if (dial && dialLabel) {
      dial.addEventListener('change', function () {
        dialLabel.textContent = dial.value;
      });
    }

    if (dial && phone && phone.form) {
      phone.form.addEventListener('submit', function () {
        var typed = phone.value.trim();
        if (!typed || typed.charAt(0) === '+') return;

        // A national number is written with a trunk zero that an international
        // one does not carry: 0600 123 456 is +48 600 123 456, never +48 0600.
        var digits = typed.replace(/\D/g, '').replace(/^0+/, '');
        if (digits) phone.value = dial.value + digits;
      });
    }

    // A form that came back with errors or a success message is the reader
    // mid-conversation with this popup — it reopens immediately rather than
    // hiding the outcome of what they just submitted.
    if ($('.popup__msg', popup)) {
      panelOpen(popup);
      return;
    }

    if (dismissedRecently()) return;

    // Any way out counts as an answer: the close button, the overlay, Escape.
    // panelClose is shared, so this watches the panel rather than the control.
    popup.addEventListener('transitionend', function () {
      if (popup.getAttribute('data-open') === 'false') remember();
    });

    window.setTimeout(function () {
      // Never over an open cart or search panel — the reader is mid-task.
      if (!openPanel) panelOpen(popup);
    }, delay);
  }

  /* --- a line of rotors ---------------------------------------------------- */

  /* Every character becomes a column of glyphs inside a one-line window, and
     the whole column slides up until the right one is showing. One transform
     interpolation per character, started once and never touched again while it
     runs — the motion is a CSS transition, so no frame of it depends on this
     thread being free.

     Shared by the loading screen and the password page, which are the same
     idea seen twice: a line of type assembling itself out of a spin. Returns
     the moment the last drum lands, measured from the page's own clock, for a
     caller that has something to do when it does.

     Accepts:
       line   — the element the rolling attribute is set on
       holder — the element whose text is replaced by the drums
       text   — what the drums land on */
  function rollLine(line, holder, text) {
    // What a rotor can carry. A space is left alone — a drum of blanks rolling
    // onto a blank is motion with nothing to read in it.
    var DRUM = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var DEPTH = 14;      // glyphs per drum, the last one being the answer
    var STAGGER = 65;    // ms between one drum starting and the next
    var SPIN = 1000;     // matches the transition in the stylesheet
    var REST = 420;      // beat between the last drum landing and whatever follows

    var chars = text.split('');
    var frag = document.createDocumentFragment();

    chars.forEach(function (ch, i) {
      if (ch === ' ') {
        frag.appendChild(document.createTextNode(' '));
        return;
      }

      var roll = document.createElement('span');
      roll.className = 'roll';

      var strip = document.createElement('span');
      strip.className = 'roll__strip';
      // Each drum starts at a different place on the ring, so the row spins as
      // a spread of glyphs rather than as one word sliding sideways.
      var offset = (i * 11) % DRUM.length;

      for (var g = 0; g < DEPTH; g++) {
        var glyph = document.createElement('span');
        glyph.className = 'roll__glyph';
        glyph.textContent = g === DEPTH - 1
          ? ch
          : DRUM.charAt((offset + g * 5) % DRUM.length);
        strip.appendChild(glyph);
      }

      // Travel is expressed in the strip's own line height so it stays correct
      // if the type scales.
      strip.style.setProperty('--roll-to', '-' + ((DEPTH - 1) * 1.15) + 'em');
      strip.style.transitionDelay = (i * STAGGER) + 'ms';

      roll.appendChild(strip);
      frag.appendChild(roll);
    });

    holder.textContent = '';
    holder.appendChild(frag);
    // The line is the accessible copy; the drums are decoration on the way to
    // it, and a screen reader should be handed the answer, not the spinning.
    holder.setAttribute('aria-label', text);

    /* Two frames before the flip: one for the drums to be laid out at their
       starting offset, one for that position to be the transition's genuine
       starting value. Flipping in the same frame they were built gives the
       browser no previous value to interpolate from, and every drum simply
       appears on its answer. */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        line.setAttribute('data-rolling', 'true');
      });
    });

    return (chars.length - 1) * STAGGER + SPIN + REST;
  }

  /* --- password page ------------------------------------------------------- */

  /* The drop line assembles itself the way the loading line does. Nothing here
     gates the page: the form beside it is Shopify's own and posts with no
     script at all, and a line that never rolls is simply a line. */
  function initPasswordLine() {
    var line = $('.password__line[data-roll]');
    if (!line) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var holder = $('[data-roll-text]', line);
    var text = holder ? holder.textContent.trim() : '';
    if (!text) return;

    rollLine(line, holder, text);
  }

  /* The gate opens once and does not close by itself: there is nothing behind
     it to go back to. All this does is flip one attribute — the plus losing its
     upright, the word collapsing away and the crossbar running out to the right
     are every one of them CSS transitions on that attribute, so the motion does
     not depend on this thread and closing is the same three read backwards.

     The form is inert while shut so the field is not tabbed into through a
     closed door, and it is un-inerted before focus, not after. */
  function initPasswordGate() {
    var gate = $('[data-gate]');
    if (!gate) return;

    var button = $('[data-gate-open]', gate);
    var form = $('.password__form', gate);
    var field = $('#storefront-password', gate);
    if (!button || !form) return;

    var open = gate.getAttribute('data-open') === 'true';

    function shut(state) {
      // inert is not everywhere yet; the tabindex is the same promise kept by
      // hand where it is missing.
      if ('inert' in HTMLElement.prototype) form.inert = state;
      else if (field) field.tabIndex = state ? -1 : 0;
    }

    shut(!open);
    /* Only ever after a refusal, which is the only way this arrives open. A
       phone answers focus with the keyboard, and a page whose whole design is
       a mark, a line and a plus should not arrive half-covered by one. */
    if (open && field) field.focus();

    /* Opened, and left alone.

       This used to focus the field the moment the plus was pressed, which on a
       phone is not a focus — it is the keyboard coming up over the bottom half
       of the screen. It arrived on the same frame the gate started opening, so
       the viewport shrank underneath an animation that was still running: the
       line stopped mid-fall, the layout jumped, and the whole gesture read as
       broken. The one thing the page is designed to do, ruined by helpfulness.

       The keyboard belongs to the field, and the field is what raises it — a
       press on the plus asks for the door, a press in the field asks to type.
       Two gestures, two answers. What is still done here is un-inerting the
       form, so the field can be reached the moment it is there. */
    function setOpen(state) {
      if ((gate.getAttribute('data-open') === 'true') === state) return;
      gate.setAttribute('data-open', state ? 'true' : 'false');
      button.setAttribute('aria-expanded', state ? 'true' : 'false');
      shut(!state);
    }

    button.addEventListener('click', function () { setOpen(true); });

    /* Anywhere off the field puts the door back. The way in is a caption on a
       page with nothing else on it, and a field left standing open behind a
       reader who has moved on is the one piece of furniture here.

       The plus is outside the form as well, and its own press is the one that
       opened this — so it is excluded by name. Without that, opening and
       closing were the same gesture and the gate never stayed open. */
    document.addEventListener('click', function (e) {
      if (gate.getAttribute('data-open') !== 'true') return;
      if (form.contains(e.target) || button.contains(e.target)) return;
      setOpen(false);
    });

    // A reader who opened this with a keyboard should not have to find the plus
    // again to shut it.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    /* --- the wrong password ------------------------------------------------

       Shopify's own form posts, is refused, and sends the whole page back with
       the error on it — so the refusal arrived after a reload, which is a black
       screen, a gate opening again and only then the shake. Half a second in
       which the answer is obvious and the page is still assembling itself.

       Posted from here instead. Shopify decides exactly as before, this only
       asks it without leaving: right password and it redirects, which is
       followed by hand; wrong and the field shakes with the page never having
       moved and the cursor still in it.

       Every way this can fail — no fetch, a dropped connection, an answer that
       cannot be read — falls back to letting the form post itself, because a
       password page that cannot be submitted is worse than one that blinks. */
    var status = $('[data-gate-status]', form);
    var sending = false;

    function refuse() {
      // Removed, forced through a layout, put back: an animation already on the
      // element does not restart because the attribute is set again, and the
      // second wrong password has to shake exactly like the first.
      gate.removeAttribute('data-refused');
      void gate.offsetWidth;
      gate.setAttribute('data-refused', '');

      if (status) {
        status.textContent = '';
        status.textContent = status.getAttribute('data-refused-text') || '';
      }

      if (field) {
        field.setAttribute('aria-invalid', 'true');
        field.value = '';
        field.focus();
      }
    }

    if (window.fetch && window.FormData) {
      form.addEventListener('submit', function (e) {
        if (sending) {
          e.preventDefault();
          return;
        }
        if (field && !field.value) return;   // let the browser ask for it

        e.preventDefault();
        sending = true;

        window.fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          redirect: 'follow',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (res) {
          /* The only tell worth trusting. A refusal comes back as the password
             page again, at the password URL; the way in is a redirect to
             somewhere that is not it. Reading the body for an error string
             would be reading a translation. */
          var through = res.redirected && !/\/password(\/|\?|$)/.test(res.url);

          if (through) {
            window.location.href = res.url;
            return;
          }

          sending = false;
          refuse();
        }).catch(function () {
          // Never leave the reader holding a field that does nothing.
          sending = false;
          form.submit();
        });
      });
    }
  }

  /* --- preloader ----------------------------------------------------------- */

  /* The screen is already up: the section's own inline script revealed it and
     armed a timer that tears it down whether or not this runs. Everything here
     builds the drums and starts them once; the motion itself is a CSS
     transition, so no frame of it depends on this thread being free.

     Every exit path removes the same class that timer would have removed. */
  /* The digits on the end of the line.

     One timer, one string, replaced whole on every tick: the letters in front
     of it never move, so the only thing running while the page is fetched is a
     readout ticking over. It says "still working" without saying how long,
     which is the one promise a loading screen cannot keep.

     Fast enough to be unreadable, which is the point — a counter you can read
     digit by digit is a number, and this is a state. */
  function startCounter(pre) {
    var cell = $('[data-count]', pre);
    if (!cell) return function () {};

    var answer = cell.getAttribute('data-count') || cell.textContent;
    var width = answer.length;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return function () {};
    }

    var timer = window.setInterval(function () {
      var out = '';
      for (var i = 0; i < width; i++) {
        out += String(Math.floor(Math.random() * 10));
      }
      cell.textContent = out;
    }, 70);

    // Landing is part of stopping: whatever the last tick left on screen, the
    // screen goes out on the real number.
    return function () {
      window.clearInterval(timer);
      cell.textContent = answer;
    };
  }

  /* The squares either side of the line.

     Each is a four-face drum — square, 0, 2, 6 — turned by the same kind of
     transform the counter uses, so the row is the same mechanism rather than a
     second effect running beside it. A turn picks one of the three digits at
     random, holds it, and comes back to the square.

     One timer per square, each rescheduling itself off its own random gap. A
     single shared interval would put the whole row on one clock, and thirteen
     squares turning together is a progress bar — the one thing a loading
     screen must never look like.

     Every square turns, and every square turns on its own. The first gap is
     drawn at random from under half a second and every gap after it from
     under a second, so the whole row is moving inside the first beat and no
     two squares are ever on the same clock. The screen is up for about a
     second, and the six-second range this replaced meant most of the row never
     moved at all inside it — but a fixed order would have been worse: the
     moment the row turns in sequence it is a progress bar. */
  function startDrums(pre) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return function () {};
    }

    var FACE = 1.15;     // face height in em, matching the stylesheet
    var FACES = 3;       // digits on the drum, the square being the rest face
    var timers = [];
    var drums = [];

    $$('[data-dot]', pre).forEach(function (dot) {
      var drum = $('[data-dot-drum]', dot);
      if (!drum) return;

      var slot = drums.length;
      drums.push(drum);

      // The opening gap is shorter than the ones after it — every square has
      // to have turned once before the screen goes — but it is still drawn
      // rather than assigned, so nothing about the row is in step.
      var first = true;

      function rest() {
        var gap = first
          ? 60 + Math.random() * 420
          : 200 + Math.random() * 900;
        first = false;
        timers[slot] = window.setTimeout(turn, gap);
      }

      function turn() {
        var face = 1 + Math.floor(Math.random() * FACES);
        drum.style.transform = 'translateY(-' + (face * FACE) + 'em)';
        // Long enough to be read as a digit rather than as a glitch, short
        // enough that the square is still what the row is made of.
        timers[slot] = window.setTimeout(function () {
          drum.style.transform = '';
          rest();
        }, 260 + Math.random() * 420);
      }

      rest();
    });

    return function () {
      timers.forEach(function (t) { window.clearTimeout(t); });
      // Back to the resting face on the way out, so nothing is caught mid-turn
      // under the exit.
      drums.forEach(function (d) { d.style.transform = ''; });
    };
  }

  function initPreloader() {
    var pre = $('[data-preloader]');
    if (!pre) return;
    if (!document.documentElement.classList.contains('is-preloading')) return;

    // Started before anything below can return early: every path still leaves
    // the screen up for a beat, and a dead readout during it is worse than no
    // readout at all. land() is called on the way out of all of them.
    var land = startCounter(pre);
    var stopDrums = startDrums(pre);

    function done() {
      land();
      stopDrums();
      /* A beat on the answer before the screen goes. Without it the counter
         lands and the fade starts in the same frame, so the number it spent
         the whole load counting towards is the one thing never seen. */
      window.setTimeout(function () {
        pre.setAttribute('data-done', 'true');
        try {
          sessionStorage.setItem('ks-preloaded', '1');
        } catch (e) { /* private mode — it plays again, which is only a cost of
                         taste, not of access */ }
        // Held until the sheet is all the way off the page. Cut short, the
        // screen would vanish mid-travel and the slide would read as a flicker.
        window.setTimeout(function () {
          document.documentElement.classList.remove('is-preloading');
        }, 600);
      }, 380);
    }

    /* The page decides when this ends, with a floor under it. A load that
       finishes in 200ms would otherwise flash the mark and take it away again,
       which reads as a fault rather than as a screen. */
    var FLOOR = 900;
    var start = performance.now();

    function finish() {
      window.setTimeout(done, Math.max(0, FLOOR - (performance.now() - start)));
    }

    if (document.readyState === 'complete') {
      finish();
    } else {
      window.addEventListener('load', finish);
    }
  }

  /* --- gallery -------------------------------------------------------------

     An index of drops and a carousel per drop, on one page, with the hash as
     the only state. Opening a drop is a class flip: everything is already
     rendered, so there is nothing to fetch and the browser's own Back button
     is the way out without a line of code spent on it.

     The hash is what the markup already used — the index lines are anchors to
     the drops and work with the script switched off — so this only has to stop
     the browser jumping and let the same hash mean "show this one". */

  var galleryHashBound = false;
  var gallerySync = null;
  /* Published by the gallery so the router can put an open drop away without
     knowing anything about how the gallery works. A no-op on every page that
     has no gallery on it, which is most of them. */
  var closeGalleryDrop = function () {};

  function initGalleryIndex() {
    var root = $('[data-gallery-root]');
    if (!root) { gallerySync = null; closeGalleryDrop = function () {}; return; }

    var index = $('[data-gallery-index]', root);
    var drops = $$('[data-gallery-drop]', root);
    if (!index || !drops.length) return;

    function slugFromHash() {
      var h = (window.location.hash || '').replace(/^#/, '');
      if (h.indexOf('drop-') !== 0) return '';
      return h.slice(5);
    }

    function show(slug) {
      var found = false;

      drops.forEach(function (drop) {
        var on = drop.getAttribute('data-gallery-drop') === slug;
        if (on) found = true;
        if (on) drop.setAttribute('data-open', 'true');
        else drop.removeAttribute('data-open');
      });

      index.setAttribute('data-hidden', found ? 'true' : 'false');
      root.setAttribute('data-view', found ? 'drop' : 'index');

      /* The carousel is wired up now that its drop has a size. It could not be
         done at boot: this drop was closed then, and every figure the track
         needs to lay itself out reads as zero inside a closed one. Guarded
         against a second pass, so reopening a drop costs nothing. */
      if (found) {
        drops.forEach(function (drop) {
          if (drop.getAttribute('data-open') === 'true') initGallery(drop);
        });
      }

      // A drop opened from half-way down the index has to start at its own
      // top; the index it replaced does not, or coming back would lose the
      // reader's place in a list they were reading.
      if (found) window.scrollTo(0, 0);
    }

    root.addEventListener('click', function (e) {
      var open = e.target.closest('[data-gallery-open]');
      if (open) {
        e.preventDefault();
        var slug = open.getAttribute('data-gallery-open');
        if (window.history && window.history.pushState) {
          window.history.pushState({ drop: slug }, '', '#drop-' + slug);
        } else {
          window.location.hash = 'drop-' + slug;
        }
        show(slug);
        return;
      }

      if (e.target.closest('[data-gallery-close]')) {
        e.preventDefault();
        if (window.history && window.history.pushState) {
          window.history.pushState({}, '', window.location.pathname);
        }
        show('');
      }
    });

    /* The two window listeners are bound once for the life of the document, not
       once per gallery. The router can bring this page back a dozen times in a
       visit, and a listener per visit is a listener answering a hash on behalf
       of a gallery that was taken out of the document pages ago.

       What they call is republished on every init instead, so the gallery they
       reach is always the one currently on screen — and nothing at all once the
       reader has moved to a page that has no gallery on it. */
    gallerySync = function () { show(slugFromHash()); };

    closeGalleryDrop = function () {
      // Nothing open, nothing to close — and no history entry to spend on it.
      if (!slugFromHash()) return;
      if (window.history && window.history.pushState) {
        window.history.pushState({}, '', window.location.pathname);
      }
      show('');
    };

    if (!galleryHashBound) {
      galleryHashBound = true;
      window.addEventListener('popstate', function () { if (gallerySync) gallerySync(); });
      window.addEventListener('hashchange', function () { if (gallerySync) gallerySync(); });
    }

    show(slugFromHash());
  }

  /* --- one page ------------------------------------------------------------

     The document is loaded once and never thrown away again. Every link inside
     the shop is answered by fetching the page it points at and putting its
     contents where the last one was — so the rail, the search panel, the cart
     and the loading screen are built a single time, and moving around the shop
     costs a fetch instead of a full navigation. No white flash between pages,
     no second run of the loading screen, no rebuilt header.

     Two kinds of arrival, because the shop has two kinds of page:

       a page    — the catalogue, the archive, the gallery, the legal pages.
                   It replaces what is in <main>, one crossing over the other.

       a product — arrives as a sheet the width of the window, up over the page
                   it was pressed on, from the bottom edge. The page underneath
                   keeps its scroll position and is still there when the sheet
                   goes back down.

     That difference is the whole argument for it: you look *into* a garment
     from somewhere, and you should be put back where you were looking from. A
     section is a place you go; a product is a thing you pick up.

     Everything the reader can point at is still a real link to a real URL. The
     address bar and the title follow, the browser's Back and Forward buttons
     are the same gesture as the theme's own BACK and Escape, a middle click
     still opens a tab, and any URL loaded cold is the ordinary server-rendered
     page — this only ever decides whether the browser is allowed to throw the
     current document away to show it.

     Which is also the whole of the fallback: with no script, no fetch, no
     History API, or a request that fails, the link is followed and the reader
     gets the same page one navigation later.

     Checkout, the account pages and the cart page are deliberately left out.
     They post forms and hand off to Shopify's own flow, and a router in the
     middle of a payment is a router that can only ever be in the way. */

  function initOnePage() {
    if (!window.fetch || !window.DOMParser) return;
    if (!window.history || !window.history.pushState) return;

    var main = $('#main');
    if (!main) return;

    // Routes that must be a real navigation. Shopify owns what happens after
    // any of them, and none of it is this document's business.
    var HANDS_OFF = /^\/(checkout|account|cart|orders|tools|apps|services|password|challenge)(\/|$|\?)/;

    function here() {
      return window.location.pathname + window.location.search;
    }

    var pages = {};          // url -> Promise of a parsed page
    var scrolls = {};        // history seq -> where the reader left that entry
    var seq = 0;             // the seq stamped on the entry we are standing on

    var mainUrl = here();    // what <main> is currently showing
    var layer = null;        // the product sheet, built on first use
    var sheetOpen = false;
    var sheetUrl = '';
    var depth = 0;           // entries the open sheet has pushed
    var underUrl = mainUrl;  // the page an open sheet is laid over
    var homeTitle = document.title;
    var homeScroll = 0;
    var lastFocus = null;
    var busy = false;

    /* One request per URL, kept for the length of the visit: a reader who looks
       at four garments and comes back to the second should not wait for it
       twice. A failure is not kept — the next press is allowed to try again,
       and if it fails too the link is simply followed. */
    function load(url) {
      if (pages[url]) return pages[url];

      pages[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('status ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('#main');
          if (!incoming) throw new Error('no main');

          return {
            html: incoming.innerHTML,
            title: doc.title,
            // What the stylesheet reads to know which page it is dressing —
            // the legal pages, the gallery and the password screen are all
            // keyed off the template class on the body.
            bodyClass: doc.body ? doc.body.className : '',
            product: !!incoming.querySelector('[data-product-root]')
          };
        })
        .catch(function (err) {
          delete pages[url];
          throw err;
        });

      return pages[url];
    }

    /* Everything a freshly served page would have had run over it, run over
       whatever has just landed instead. The list is the boot sequence minus the
       parts that belong to the document rather than to a page in it: the
       loading screen, the popup and the header are built once and outlive every
       swap. */
    function hydrate(scope) {
      initProduct($('[data-product-root]', scope));
      initAccordions(scope);
      initCarousels(scope);
      initInfinite();
      initGallery(scope);
      initGalleryIndex();
    }

    /* Which tab the rail shows as the page you are on. The header is rendered
       once, by Liquid, against the URL the document was served at — from the
       second page onward this is what keeps it honest. */
    function markTabs() {
      var path = mainUrl.split('?')[0];
      $$('.header__nav a').forEach(function (a) {
        if (a.pathname === path) a.setAttribute('aria-current', 'page');
        else a.removeAttribute('aria-current');
      });
    }

    /* --- a page crossing another ------------------------------------------- */

    function swapMain(page, url, scrollTo) {
      main.setAttribute('data-leaving', 'true');

      /* Long enough to read as the old page leaving, short enough that it never
         becomes a wait: the whole crossing is under half a second, and the
         arriving half of it carries the same rise the cards come in on. */
      window.setTimeout(function () {
        main.innerHTML = page.html;
        mainUrl = url;
        document.title = page.title;
        homeTitle = page.title;
        if (page.bodyClass) document.body.className = page.bodyClass;

        window.scrollTo(0, scrollTo || 0);
        hydrate(main);
        rebindCatalogue();
        markTabs();

        main.removeAttribute('data-leaving');
        main.setAttribute('data-entering', 'true');
        window.setTimeout(function () {
          main.removeAttribute('data-entering');
        }, 460);
      }, 170);
    }

    /* --- the product sheet -------------------------------------------------- */

    function buildLayer() {
      layer = document.createElement('div');
      layer.className = 'pdp-layer';
      layer.setAttribute('data-pdp-layer', '');
      layer.setAttribute('data-open', 'false');
      layer.setAttribute('role', 'dialog');
      layer.setAttribute('aria-modal', 'true');
      document.body.appendChild(layer);
    }

    function showSheet(page, url) {
      if (!layer) buildLayer();

      if (!sheetOpen) {
        homeTitle = document.title;
        homeScroll = window.scrollY;
        lastFocus = document.activeElement;
        lockScroll();
        sheetOpen = true;
        underUrl = mainUrl;
        document.documentElement.setAttribute('data-pdp-sheet', 'true');
      }

      layer.innerHTML = page.html;
      layer.scrollTop = 0;
      document.title = page.title;
      layer.setAttribute('aria-label', page.title);
      sheetUrl = url;

      hydrate(layer);

      /* Two frames between filling the sheet and releasing it. The first is the
         browser laying the new markup out — the gallery inside measures itself
         during it — and the second is what gives the transform a previous value
         to travel from. Released in the same frame it was written, the sheet
         does not slide; it is simply there. */
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          layer.setAttribute('data-open', 'true');
          var back = $('.pdp__back', layer);
          if (back) back.focus({ preventScroll: true });
        });
      });
    }

    function hideSheet() {
      if (!sheetOpen) return;
      sheetOpen = false;
      sheetUrl = '';
      depth = 0;
      document.title = homeTitle;
      layer.setAttribute('data-open', 'false');
      document.documentElement.removeAttribute('data-pdp-sheet');
      unlockScroll();
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });

      /* Put the page back where it was on the next frame as well. The lock has
         already restored it, but a close running inside a popstate is followed
         by the browser's own scroll restoration for that entry — off a figure
         it recorded while the body was pinned and the document was one screen
         tall. Which is nought, and nought is the top of the archive rather than
         the row of garments the reader was looking at. */
      window.requestAnimationFrame(function () {
        if (!sheetOpen && window.scrollY !== homeScroll) window.scrollTo(0, homeScroll);
      });

      /* Emptied once it is off the screen, not before: the sheet is still
         travelling and a reader watching it leave should see the garment go
         with it. */
      window.setTimeout(function () {
        if (!sheetOpen) layer.innerHTML = '';
      }, 700);
    }

    /* Wind back over every entry the sheet pushed, in one step, so the reader
       lands on the page they came from rather than walking back out through
       each garment they looked at on the way. Only ever asks the history to
       move: the sheet comes down in the popstate that answers, so the address
       bar and the screen can never disagree. */
    function dismiss() {
      if (!sheetOpen) return;
      window.history.go(-Math.max(1, depth));
    }

    /* --- going somewhere ----------------------------------------------------- */

    function go(url, push) {
      return load(url).then(function (page) {
        if (push) {
          scrolls[seq] = sheetOpen ? homeScroll : window.scrollY;
          seq++;
          window.history.pushState({
            ks: seq,
            sheet: page.product,
            under: page.product ? (sheetOpen ? underUrl : mainUrl) : url
          }, '', url);
          if (page.product) depth++;
        }

        if (page.product) {
          showSheet(page, url);
          return;
        }

        /* A page while the sheet is up — the rail is still reachable over it,
           so this is a real thing to do. The sheet goes down onto the page it
           was laid over, and the new one crosses underneath. */
        if (sheetOpen) hideSheet();
        swapMain(page, url, 0);
      });
    }

    /* --- what counts as a link this thing should take ------------------------ */

    function routable(el) {
      var a = el.closest ? el.closest('a[href]') : null;
      if (!a) return null;
      if (a.target && a.target !== '_self') return null;
      if (a.hasAttribute('download')) return null;
      if (a.origin !== window.location.origin) return null;
      if (a.hasAttribute('data-no-router')) return null;

      // An anchor into the page being read is the browser's own job — the
      // gallery index is built out of them.
      var raw = a.getAttribute('href') || '';
      if (raw.charAt(0) === '#') return null;
      if (a.hash && a.pathname === window.location.pathname) return null;

      if (HANDS_OFF.test(a.pathname)) return null;
      return a;
    }

    /* Fetched on approach rather than on the press. A pointer resting on a card
       is most of a second of warning, and a touch is a hundred milliseconds of
       it — by the time the finger lifts the page is usually already here.

       After a beat, though, not on arrival. A pointer crossing the archive
       passes over a dozen cards on its way somewhere else, and a request per
       card it grazed is a page fetching most of the catalogue to answer a
       gesture nobody made. Ninety milliseconds is longer than a pointer takes
       to cross a card and shorter than anyone takes to decide.

       A touch has no such problem — a finger on a card is a finger that has
       already chosen — so it goes straight out. */
    var dwell = null;

    function warm(e, now) {
      var a = routable(e.target);
      if (!a) return;
      var url = a.pathname + a.search;
      if (pages[url]) return;

      window.clearTimeout(dwell);
      if (now) {
        load(url).catch(function () { /* the press will navigate instead */ });
        return;
      }
      dwell = window.setTimeout(function () {
        load(url).catch(function () { /* the press will navigate instead */ });
      }, 90);
    }

    document.addEventListener('mouseover', function (e) { warm(e, false); }, { passive: true });
    document.addEventListener('mouseout', function () { window.clearTimeout(dwell); }, { passive: true });
    document.addEventListener('touchstart', function (e) { warm(e, true); }, { passive: true });

    document.addEventListener('click', function (e) {
      // Anything the browser would treat as "not an ordinary click" is left to
      // the browser: a new tab, a new window, a download, a saved link.
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (!e.target || !e.target.closest) return;

      // BACK inside the sheet is the sheet's own way out, not a navigation.
      if (layer && e.target.closest('[data-pdp-layer] .pdp__back')) {
        e.preventDefault();
        dismiss();
        return;
      }

      var a = routable(e.target);
      if (!a) return;

      var url = a.pathname + a.search;
      /* A link to the page already open. There is nothing to fetch, but there
         may still be something to do: the gallery is two views on one URL, and
         pressing GALLERY while a drop is open should put the reader back at
         the index rather than answer with nothing at all. Anything else that
         points at where you already are keeps its old behaviour, which is to
         do exactly that. */
      if (url === (sheetOpen ? sheetUrl : mainUrl)) {
        e.preventDefault();
        if (!sheetOpen && gallerySync) closeGalleryDrop();
        return;
      }

      e.preventDefault();
      if (busy) return;
      busy = true;

      // A panel belongs to the page that was open behind it.
      if (openPanel) panelClose();

      go(url, true)
        .catch(function () {
          // The one thing this must never do is swallow a press. Whatever went
          // wrong, the link still goes where it says it goes.
          window.location.href = a.href;
        })
        .then(function () { busy = false; });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !sheetOpen) return;
      // The panels sit above the sheet and answer Escape first.
      if (openPanel) return;
      dismiss();
    });

    window.addEventListener('popstate', function (e) {
      var state = e.state || window.history.state;
      var url = here();

      /* Not one of ours — an entry written before this document was loaded, or
         by something outside the theme. There is nothing to swap to, but an
         open sheet has to come down: whatever the reader has just arrived at,
         it is not the garment. */
      if (!state || typeof state.ks !== 'number') {
        if (sheetOpen) hideSheet();
        return;
      }

      seq = state.ks;

      if (state.sheet) {
        depth = 1;
        // The page underneath has to be the one the sheet was opened over
        // before the sheet can be laid on it again.
        var chain = (mainUrl === state.under)
          ? Promise.resolve()
          : load(state.under).then(function (page) { swapMain(page, state.under, 0); });

        chain
          .then(function () { return load(url); })
          .then(function (page) { showSheet(page, url); })
          .catch(function () { window.location.reload(); });
        return;
      }

      if (sheetOpen) hideSheet();
      if (mainUrl === url) return;

      load(url)
        .then(function (page) { swapMain(page, url, scrolls[state.ks] || 0); })
        .catch(function () { window.location.reload(); });
    });

    /* Published for the category rail, which changes the URL without leaving
       the page. Routed through here so the entry it writes is stamped like
       every other and <main>'s own idea of where it is stays true — otherwise
       a sheet opened from a filtered catalogue would remember the unfiltered
       one as the page underneath it. */
    routerPush = function (url, extra) {
      scrolls[seq] = window.scrollY;
      seq++;
      var state = { ks: seq, sheet: false, under: url };
      if (extra) {
        Object.keys(extra).forEach(function (k) { state[k] = extra[k]; });
      }
      window.history.pushState(state, '', url);
      mainUrl = url;
    };

    /* The entry the document was served on is stamped like any other, so every
       popstate from here has a state to read and none of them has to guess. */
    window.history.replaceState({ ks: 0, sheet: false, under: mainUrl }, '', here());
    markTabs();
  }
  /* --- boot -------------------------------------------------------------- */

  function boot() {
    initPreloader();
    initPasswordLine();
    initPasswordGate();
    initProduct($('[data-product-root]'));
    initAccordions(document);
    initCarousels(document);
    initInfinite();
    initGallery(document);
    initGalleryIndex();
    initNewsletterPopup();
    initOnePage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function (e) {
    initProduct($('[data-product-root]', e.target) || $('[data-product-root]'));
    initAccordions(e.target);
    initCarousels(e.target);
    initInfinite();
    initGallery(e.target);
    initGalleryIndex();
  });
})();
